// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__FHL-f","form":"styles_form__2RsmR"};